module.exports = __webpack_public_path__ + "adc3a8fdd586f7d5764dff6292c2af9a.svg";